
import React                 from 'react';
import { observer, inject  } from 'mobx-react';

import { Menu              } from './commun/Menu';
import { Bandeau           } from './commun/Bandeau';
import { BandeauSmartphone } from './commun/BandeauSmartphone';

/* *********************************************************************************** */
/* **********                                                               ********** */
/* **********                                Carte                          ********** */
/* **********                                                               ********** */
/* *********************************************************************************** */

export const Carte = inject(['store'])(observer(class Carte extends React.Component {

  /* ---------------------- */
  /* Affichage du composant */
  /* ---------------------- */

  render() {

    const largeur = this.props.store.largeurBandeau + 'px' ;

    /* ------------------------------ */
    /* Définition des CSS d'affichage */
    /* ------------------------------ */

    const styleBlocTexte = {
      width           : this.props.largeur ? this.props.largeur : "1063px",
      display         : "block",
      marginTop       : "30px",
      marginLeft      : "auto",
      marginRight     : "auto",
      marginBottom    : "10px",
      textAlign       : 'center'      
  };


    /* ----------------------------------------- */
    /* Définition de l'onglet du menu à afficher */
    /* ----------------------------------------- */

    this.props.store.definirSelectionOnglet ("carte");

    /* ------------------------------- */
    /* Définition du titre de l'onglet */
    /* ------------------------------- */

    document.title = "Cartes - La geste d'Aros";

    /* -------------------------------- */
    /* Formatage des données à afficher */
    /* -------------------------------- */

  const znBandeau = window.innerWidth < 1080 ?  <BandeauSmartphone /> : <Bandeau largeur={largeur} />;

    /* ------------------- */
    /* Renvoi du composant */
    /* ------------------- */

    return (

        <div id='divCarte' style={{textAlign:'center'}}> 

              {znBandeau}

              <Menu menu = {this.props.store.menu} />

              <div style={styleBlocTexte}>  

                  <p className="Accueil">
                      Les royaumes du Sud
                    </p>

              </div>

                  <div className="sud"> </div>

                  <br /><br /><br />

                  <p className="Accueil">
                      L'ancien Empire
                    </p>

                  <div className="imperium"> </div>



        </div>
      )
    } 
  } // Fin de la classe Carte
))



// WEBPACK FOOTER //
// ./src/components/Carte.js